import { DocumentUpload } from './DocumentUpload';

const UploadToolRoute = {
  path: '/accounting/uploadtool',
  load: () => import('./UploadTool'),
  protected: true,
};

export { DocumentUpload, UploadToolRoute };
